module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.069168c1.png";